import { useEffect, useState } from "react";
import { CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import { useScriptMode } from "../../../contexts/ScriptModeContext";
import { SoftButton, cls, useDialogPaperSx } from "../../hatim/soft/SoftKit";
import { TEMPLATE_NAME_MAX } from "./goalItems";

// Çekmecenin (z-index 1401) üstünde açılsın.
const OVER_DRAWER = { zIndex: 1500 };

/** Şablon adı: yeni kayıt ve yeniden adlandırma (mobil TemplateNameModal). */
export default function TemplateNameDialog({ open, title, initialName = "", busy, error, onCancel, onSubmit }) {
  const { t } = useScriptMode();
  const paperSx = useDialogPaperSx();
  const [name, setName] = useState(initialName);

  useEffect(() => {
    if (open) setName(initialName);
  }, [open, initialName]);

  const trimmed = name.trim();
  const canSave = trimmed.length > 0 && !busy;

  return (
    <Dialog
      open={Boolean(open)}
      onClose={busy ? undefined : onCancel}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: paperSx }}
      sx={OVER_DRAWER}
    >
      <DialogTitle sx={{ fontWeight: 500, fontSize: 17 }}>{title}</DialogTitle>
      <DialogContent>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            if (canSave) onSubmit(trimmed);
          }}
        >
          <TextField
            autoFocus
            fullWidth
            size="small"
            margin="dense"
            label={t("bulk_template_name")}
            value={name}
            onChange={(e) => setName(e.target.value.slice(0, TEMPLATE_NAME_MAX))}
            inputProps={{ maxLength: TEMPLATE_NAME_MAX }}
            helperText={`${name.length} / ${TEMPLATE_NAME_MAX}`}
          />
        </form>
        {error ? (
          <p role="alert" className={`mt-1 text-sm ${cls.danger}`}>
            {error}
          </p>
        ) : null}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <SoftButton tone="cancel" onClick={onCancel} disabled={busy}>
          {t("cancel")}
        </SoftButton>
        <SoftButton tone="success" onClick={() => onSubmit(trimmed)} disabled={!canSave}>
          {busy ? <CircularProgress size={18} color="inherit" /> : t("save")}
        </SoftButton>
      </DialogActions>
    </Dialog>
  );
}

/** Şablon silme onayı; hedef listesi yerinde kalır, yalnız şablon silinir. */
export function ConfirmTemplateDelete({ open, name, loading, onCancel, onConfirm }) {
  const { t } = useScriptMode();
  const paperSx = useDialogPaperSx();
  return (
    <Dialog
      open={Boolean(open)}
      onClose={loading ? undefined : onCancel}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: paperSx }}
      sx={OVER_DRAWER}
    >
      <DialogTitle sx={{ fontWeight: 500, fontSize: 17 }}>{t("bulk_delete_template_title")}</DialogTitle>
      <DialogContent>
        <p className={`text-sm ${cls.muted}`}>{t("bulk_delete_template_body", { name: name || "" })}</p>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <SoftButton tone="cancel" onClick={onCancel} disabled={loading}>
          {t("cancel")}
        </SoftButton>
        <SoftButton tone="danger" onClick={onConfirm} disabled={loading}>
          {t("delete")}
        </SoftButton>
      </DialogActions>
    </Dialog>
  );
}
